export default {"src":"/_next/static/media/Original.66903145.svg","height":26,"width":117,"blurWidth":0,"blurHeight":0};